var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 6.524H21.692V0.84C21.692 0.364 21.328 0 20.852 0H1.02799C0.551988 0 0.187988 0.364 0.187988 0.84V14.868C0.187988 15.344 0.551988 15.708 1.02799 15.708H10.1V17.668H6.68399C6.20799 17.668 5.84399 18.032 5.84399 18.508C5.84399 18.984 6.20799 19.348 6.68399 19.348H15.168C15.644 19.348 16.008 18.984 16.008 18.508C16.008 18.032 15.644 17.668 15.168 17.668H11.78V15.708H15.672C16.148 15.708 16.512 15.344 16.512 14.868C16.512 14.392 16.148 14.028 15.672 14.028H1.86799V1.68H20.012V6.524H18.752C18.276 6.524 17.912 6.888 17.912 7.364V18.536C17.912 19.012 18.276 19.376 18.752 19.376H25.5C25.976 19.376 26.34 19.012 26.34 18.536V7.364C26.34 6.888 25.976 6.524 25.5 6.524ZM24.66 17.696H19.592V8.204H24.66V17.696Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTabIcon);
export default __webpack_public_path__ + "static/media/deviceTabIcon.6e01e54e3110701807591ad4527cd6b9.svg";
export { ForwardRef as ReactComponent };